import { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import BlogList from "@/pages/blog/BlogList";
import BlogArticle from "@/pages/blog/BlogArticle";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogList />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;